<template>
  <div class="page403">
    <div class="content">
      <span class="icon-auth"/>
      <br>
      <span>暂无权限</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page403'
}
</script>

<style lang="scss" scoped>
  .icon-auth {
    display: inline-block;
    margin-bottom: 5px;
    font-size: 40px;
  }
  .page403 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 100px;
    background-color: #fff;
    color: #bac1cc;
    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 14px;
    }
  }
</style>
